import { FC } from 'react';

import { MagritteNotificationName } from 'utils/constants/notification';

import { Alert, Button, ButtonStack } from '@hh.ru/magritte-ui';
import { ArchiveboxOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { fetchArchiveCampaign } from 'components/CampaignAdminActions/ArchiveCampaignAlert/fetchArchiveCampaign';

import { selectCampaignArchiveModalShow, setCampaignArchiveModalShow } from 'store/autoReducers';
import { setIdAdminAction, setLoadCampaignAdminAction } from 'store/models/adminCampaignAction';
import { addMagritteNotification } from 'store/models/notification';
import { useDispatch, useSelector } from 'store/utils';

const Trls = {
    title: 'campaign.info.sudo.actions.archiveCampaign.modal.title',
    description: 'campaign.info.sudo.actions.archiveCampaign.modal.description',
    archive: 'campaign.info.sudo.actions.archiveCampaign.modal.archive',
    cancel: 'campaign.info.sudo.actions.archiveCampaign.modal.cancel',
};

export const ArchiveCampaignAlert: FC = () => {
    const isAlertVisible = useSelector(selectCampaignArchiveModalShow);
    const campaignId = useSelector((state) => state.adminCampaignAction.campaignId);
    const dispatch = useDispatch();
    const trls = useTrls();

    const handleClose = () =>
        dispatch([setCampaignArchiveModalShow(false), setIdAdminAction(null), setLoadCampaignAdminAction(false)]);

    const handleArchive = () => {
        if (campaignId) {
            void dispatch(fetchArchiveCampaign(campaignId));
        } else {
            dispatch(addMagritteNotification(MagritteNotificationName.CampaignArchiveError));
        }
    };

    return (
        <Alert
            visible={isAlertVisible}
            title={trls(Trls.title)}
            description={trls(Trls.description)}
            buttons={
                <ButtonStack stretched>
                    <Button mode="secondary" style="accent" onClick={handleClose}>
                        {trls(Trls.cancel)}
                    </Button>
                    <Button mode="primary" style="negative" onClick={handleArchive}>
                        {trls(Trls.archive)}
                    </Button>
                </ButtonStack>
            }
            onClose={handleClose}
        >
            <ArchiveboxOutlinedSize24
                initialColor="secondary"
                backgroundStyle="dreamy-secondary"
                padding={12}
                borderRadius="halfHeight"
            />
        </Alert>
    );
};
